import React, { Component } from "react";
import classes from "./login.module.css";
import Button from "./button";
import axios from "../../Axios";
import OtpInput from "react-otp-input";
import { notification } from "antd";
import { withRouter } from "react-router";

const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};
class Otp extends Component {
  state = { otp: "", email: localStorage.getItem("currentEmail"), loading: false };

  sendRequest = () => {
    this.setState({loading: true});
    axios.post("/admin/verify", this.state).then((res) => {
      this.setState({loading: false});
      const { data } = res;
      if (data.error) {
        openNotificationWithIcon(
          "error",
          "Verfication Failed",
          `Verification failed due to ${data.message}`
        );
      } else if (data.auth) {
        this.props.history.push("/");
        openNotificationWithIcon(
          "success",
          "Email Verified",
          `Login To Continue`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Verfication Failed",
          `Verification failed due to ${data.message}`
        );
      }
    }).catch(err=>{
      this.setState({loading: false});
      openNotificationWithIcon(
        "error",
        "Verfication Failed",
        `Verification failed due to ${err}`
      );
    });
  };

  
  clickHandler = () => {
    axios
    .post("/admin/resend",{email:localStorage.getItem("currentEmail")})
    .then((res) => {
      const { data } = res;
      if (data.error) {
        openNotificationWithIcon(
          "error",
          "Try Again",
          `Resend failed due to ${data.message}`
        );
      } else if (data.auth) {
        openNotificationWithIcon(
          "success",
          "OTP",
          `An OTP has been sent to ${localStorage.getItem("currentEmail")}. Enter OTP to get verified`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Try Again",
          `Resend failed due to ${data.message}`
        );
      }
    })
    .catch((err) => {
      openNotificationWithIcon("error", "Something went wrong", `${err}`);
    });

  };

  handleChange = (otp) => {
    this.setState({ otp }, () => {
      if (this.state.otp.length === 6) {
        this.sendRequest();
      }
    });
  };
  render() {
    const {loading} = this.state;
    return (
      <React.Fragment>
        <h1 className={classes.login}>verify your account</h1>
        <span className={classes.text}>An OTP has been sent to your e-mail</span>

        <OtpInput
          value={this.state.otp}
          onChange={this.handleChange}
          numInputs={6}
          separator={<span></span>}
          inputStyle={classes.otp}
          isInputNum={true}
          focusStyle={classes.focusStyle}
        />
        <Button onClick={this.clickHandler} extraClass={classes.button} isLoading={loading}>
          Resend
        </Button>
      </React.Fragment>
    );
  }
}

export default withRouter(Otp);
